import { phoneNumbersMasks } from '@/utils/mask'
import { Input } from '@material-tailwind/react'
import InputMask from 'react-input-mask'

export const PhoneNumberInput = ({ value, onChange, disabled, ...props }) => {
  const defaultCountry = 'CL'

  return (
    <InputMask disabled={disabled} value={value} onChange={onChange} mask={phoneNumbersMasks[defaultCountry]}>
      <Input
        {...props}
      />
    </InputMask>
  )
}
